import {mergeProperties} from "../components/Utility";

export const vendorLoginFormModel = (data) => {
    const initialData = {
        phone: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};




